const ruRules = new Intl.PluralRules("ru-RU");

/**
 * Picks the correct Russian word form for a count using the platform's CLDR
 * plural rules (no hand-rolled mod10/mod100, which is where the naive variants
 * mis-rendered 11-14 / 21 / etc.).
 *
 *   pluralizeRu(1,  ["балл", "балла", "баллов"]) // "балл"
 *   pluralizeRu(2,  ["балл", "балла", "баллов"]) // "балла"
 *   pluralizeRu(5,  ["балл", "балла", "баллов"]) // "баллов"
 *   pluralizeRu(12, ["балл", "балла", "баллов"]) // "баллов"
 *   pluralizeRu(21, ["балл", "балла", "баллов"]) // "балл"
 *
 * @param {number} n
 * @param {[one: string, few: string, many: string]} forms
 * @returns {string} the word form (does not include the number)
 */
export default function pluralizeRu(n, [one, few, many]) {
    const category = ruRules.select(n); // 'one' | 'few' | 'many' | 'other'
    if (category === "one") return one;
    if (category === "few") return few;
    // 'many' (5-20, 25-30, ...) and 'other' (only reached by fractions) → genitive plural
    return many;
}
